module.exports = __webpack_public_path__ + "img/slide_3.7381ede9.png";